import classNames from 'classnames'
import { FC } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import { t } from 'i18next'

import { Portal } from '@lounge-fe/ui-kit/src/components/Portal'
import { Button } from '@lounge-fe/ui-kit/src/components/Button'
import { Icon } from '@lounge-fe/ui-kit/src/components/Icon'
import { useDisclosure } from '@lounge-fe/ui-kit/src/hooks'
import { useCollectionContext } from '../../Collection'

import { Form } from '../Form'
import { FilterByProps } from '../types'

export const FilterByDesktop = ({
  sections,
  name,
}: FilterByProps): JSX.Element => {
  const { isOpen, onToggle, onClose } = useDisclosure()
  const { productContainerRef } = useCollectionContext()

  return (
    <>
      <Button
        className="w-full h-full rounded-[0] pl-2 hover:enabled:bg-transparent normal-case typography typography--body-sm"
        variant="ghost"
        onClick={onToggle}
        endIcon={
          <Icon.ChevronDown
            className={classNames('w-2 transition', isOpen && 'rotate-180')}
          />
        }
      >
        {isOpen ? t('action.hide_filters') : t('action.show_filters')}
      </Button>
      <Portal containerRef={productContainerRef}>
        <AnimatePresence>
          {isOpen && (
            <motion.aside
              initial={{ marginLeft: -334, opacity: 0 }}
              animate={{ marginLeft: 0, opacity: 1 }}
              exit={{ marginLeft: -334, opacity: 0 }}
              transition={{ duration: 0.33 }}
              className="sticky top-[calc(var(--header-height)_-_theme(spacing.8))]"
            >
              <div className="w-[334px] max-h-screen overflow-y-auto px-7 py-8 right-0">
                <Form
                  name={name}
                  sections={sections}
                  showActions={false}
                  onClose={onClose}
                />
              </div>
            </motion.aside>
          )}
        </AnimatePresence>
      </Portal>
    </>
  )
}
